import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComponentDataShareService {
  private shareData$ = new BehaviorSubject<any>({});
  messagePassed$ = this.shareData$.asObservable();

  constructor() {}

  setMessage(message: any): void {
    this.shareData$.next(message);
  }
}
